/**
 * Layout: Password
 * -----------------------------------------------------------------------------
 * Entry file for all global password scripts.
 *
 */

/**
 * Core scripts.
 */
import '~/core/lazysizes'
import Bugsnag from '~/core/bugsnag'
import Canvas from '~/core/canvas'
import Commands from '~/core/commands'
import DomReady from '~/core/dom-ready'

/**
 * Global Canvas functions.
 */
window.cnvs = window.cnvs || {}
window.cnvs.DomReady = (callback) => DomReady(callback)
window.cnvs.Helpers = Commands().cli()

/**
 * DOM ready.
 */
cnvs.DomReady(() => {
  Bugsnag().init()
  Commands().init()

  Canvas().init()
})
